import { GET_SURVEY_REQUEST, SET_LANGUAGE_CODE, SET_SURVEY_ID, SET_SURVEY_NAME } from "../constant";

const initialState = {
  survey_id: null,
  language_code: '22',
  survey_name: null
}

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get survey
    case SET_LANGUAGE_CODE:
      return {
        ...state,
        language_code: action.payload
      }
    case SET_SURVEY_ID:
      return {
        ...state,
        survey_id: action.payload
      }

    case SET_SURVEY_NAME:
      return {
        ...state,
        survey_name: action.payload
      }

    default:
      return state;
  }
}

export { permissionsReducer }